import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import FlightsPropTypes from '../../proptypes/flights';
import { formatDateToDayShort } from '../../../../../../utils/dateUtils';
import { getFlightTypeData, getHoursSafe } from '../../utils/flightUtils';
import FlightDaysDiff from './FlightDaysDiff';
import FlightType from './FlightType';
import { unknownLuggage } from './constants';

import FlightsLuggage from './Luggage/FlightsLuggage/FlightsLuggage';

// TODO: вместо data сделать нормальные пропсы как в FlightsRouteBack
const FlightsRouteSidebar = ({
  data,
  isMobile,
  isFlightsTypeEqual,
  isDateChangable,
}) => {
  const { t } = useTranslation();
  const { arrival, departure, time, luggage: luggageFromData } = data;
  const luggage = isDateChangable ? unknownLuggage : luggageFromData;

  const timeRange = time
    ? `${getHoursSafe(departure)}-${getHoursSafe(arrival)}`
    : t('monthSegments.noData');

  const isShowingFlightType = isMobile && !isFlightsTypeEqual;

  return (
    <>
      {isShowingFlightType && (
        <FlightType
          className="checkout-sidebar-top__label"
          showFlightClass={!isDateChangable}
          showIcon={false}
          showDescription={false}
          showTooltip={!isMobile}
          type={getFlightTypeData(data)}
        />
      )}

      <div className="like-h4 nowrap">
        {!isDateChangable && <span>{timeRange}</span>}
        <FlightDaysDiff previousDate={departure} nextDate={arrival} />
      </div>

      <div className="flex flex-align-center">
        {departure && (
          <span className="checkout-sidebar-flight__date">
            {formatDateToDayShort(departure)}
          </span>
        )}
        <FlightsLuggage
          className="checkout-sidebar-flight__luggage"
          luggage={luggage}
          isMobile={isMobile}
        />
      </div>
    </>
  );
};

FlightsRouteSidebar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  data: FlightsPropTypes.item.isRequired,
  isFlightsTypeEqual: PropTypes.bool.isRequired,
};

export default FlightsRouteSidebar;
